import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";

export default function My(props) {
    const { ...rest } = props;
    const location = useLocation();
    const [open, setOpen] = React.useState(true);
    const [currentRoute, setCurrentRoute] = React.useState("Licenze");

    React.useEffect(() => {
        window.addEventListener("resize", () =>
            window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
        );
        if (!getCookie("ACCESS_TOKEN")) {
            localStorage.removeItem("ACCESS_TOKEN");
            document.cookie =
                "ACCESS_TOKEN=; SameSite=strict; Max-Age=0; path=/";
            window.location.replace("/auth/sign-in");
        }
    }, []);

    const getCookie = (name) => {
        const cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            const cookiePair = cookies[i].split("=");
            const cookieName = cookiePair[0];
            const cookieValue = decodeURIComponent(cookiePair[1]);

            if (name.trim() === cookieName.trim()) {
                return cookieValue;
            }
        }

        return localStorage.getItem(name);
    };
    React.useEffect(() => {
        getActiveRoute(routes);
    }, [location.pathname]);

    const getActiveRoute = (routes) => {
        let activeRoute = "Licenze";
        for (let i = 0; i < routes.length; i++) {
            let routePath = routes[i].path;
            let position = routePath.search("/:");
            if (position > -1) {
                routePath = routePath.slice(0, position);
            }
            if (
                window.location.href.indexOf(
                    routes[i].layout + "/" + routePath
                ) !== -1
            ) {
                setCurrentRoute(routes[i].name);
            }
        }
        return activeRoute;
    };
    const getActiveNavbar = (routes) => {
        let activeNavbar = false;
        for (let i = 0; i < routes.length; i++) {
            if (
                window.location.href.indexOf(
                    routes[i].layout + routes[i].path
                ) !== -1
            ) {
                return routes[i].secondary;
            }
        }
        return activeNavbar;
    };
    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/my") {
                return (
                    <Route
                        path={`/${prop.path}`}
                        element={prop.component}
                        key={key}
                    />
                );
            } else {
                return null;
            }
        });
    };
    document.documentElement.dir = "ltr";
    return (
        <div className="flex h-full w-full">
            <Sidebar
                open={open}
                onClose={() => {
                    if (window.innerWidth < 1200) setOpen(false);
                }}
            />

            {/* Navbar & Main Content */}
            <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
                {/* Main Content */}
                <main className={`mx-3 h-full transition-all xl:ml-[320px]`}>
                    {/* Routes */}
                    <div className="bg-blurred-logo h-full">
                        <Navbar
                            onOpenSidenav={() => setOpen(true)}
                            logoText={""}
                            brandText={
                                currentRoute === "Storico attivazioni" ||
                                currentRoute === "Attivazioni in sospeso"
                                    ? "Licenze"
                                    : currentRoute
                            }
                            secondary={getActiveNavbar(routes)}
                            {...rest}
                        />

                        <div className="mx-auto mb-auto h-full min-h-[84vh] p-2 pt-5">
                            <Routes>
                                {getRoutes(routes)}

                                <Route
                                    path="/"
                                    element={
                                        <Navigate
                                            to="/my/activation-history"
                                            replace
                                        />
                                    }
                                />
                            </Routes>
                        </div>
                        <div className="p-3">
                            <Footer />
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
}
